import React from 'react';
import { Box, Typography, TextField } from '@mui/material';

interface InvoiceTermsProps {
    terms: string;
    onChange: (terms: string) => void;
}

const InvoiceTerms: React.FC<InvoiceTermsProps> = ({ terms, onChange }) => {
    const [hasEdited, setHasEdited] = React.useState(false);

    return (
        <Box sx={{ width: '100%', flex: 1 }}>
            <Typography sx={{ fontWeight: 600, color: 'var(--color-default-text)' }}>
                Terms & Conditions <span style={{ color: '#F44336' }}>*</span>
            </Typography>
            <TextField
                fullWidth
                multiline
                rows={4}
                placeholder="Enter terms and conditions..."
                value={terms}
                onChange={(e) => {
                    setHasEdited(true);
                    onChange(e.target.value);
                }}
                sx={{
                    background: 'var(--color-page-background)',
                    '& .MuiOutlinedInput-root': {
                        fontSize: 13
                    }
                }}
            />
            {hasEdited && (
                <Typography sx={{ fontSize: 12, color: 'var(--color-text-muted)', fontStyle: 'italic', mt: 0.5 }}>
                    Note: Editing this text only affects what's displayed. It does not change invoice or provision logic.
                </Typography>
            )}
        </Box>
    );
};

export default InvoiceTerms;